var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscriptionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.503,
    height: 22.491,
    viewBox: "0 0 22.503 22.491",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2998",
    "data-name": "Group 2998",
    transform: "translate(2314 -823.24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2939",
    "data-name": "Path 2939",
    d: "M7.284,9.156V8.3H3.65C3.2,8.3,3,8.095,3,7.645V5.636A2.678,2.678,0,0,1,5.693,2.944q8.561-.007,17.122,0A2.668,2.668,0,0,1,25.5,5.621q.007,9.6,0,19.194a.542.542,0,0,1-.844.529c-.786-.389-1.57-.78-2.351-1.18a.381.381,0,0,0-.392,0c-.761.388-1.531.759-2.29,1.151a.731.731,0,0,1-.737,0c-.732-.38-1.476-.736-2.209-1.114a.531.531,0,0,0-.554-.008c-.743.39-1.5.752-2.248,1.135a.683.683,0,0,1-.677,0c-.774-.4-1.555-.778-2.329-1.172a.364.364,0,0,0-.373,0c-.774.4-1.553.781-2.332,1.168-.5.251-.881.022-.881-.536V8.917a.54.54,0,0,1,.476-.577C8.084,8.3,7.272,9.362,7.284,9.156ZM7.26,7.22A.674.674,0,0,0,7.284,7.1c0-.513.011-1.026,0-1.538a1.607,1.607,0,0,0-3.208.018c-.013.431-.005.862-.005,1.294V7.22Z",
    transform: "translate(-2316.999 820.3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-2306.751 827.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2941",
    "data-name": "Path 2941",
    d: "M250.693,63.918c0-.132,0-.272,0-.412a.536.536,0,1,1,1.071,0c0,.126,0,.252,0,.314.392.2.76.357,1.1.561a.519.519,0,0,1,.179.77.543.543,0,0,1-.806.087c-.133-.089-.279-.159-.452-.256-.007.091-.014.138-.014.186,0,.587,0,1.175,0,1.763a.206.206,0,0,0,.169.234,2.4,2.4,0,0,1,1.185.714,2.306,2.306,0,0,1-1.071,3.594c-.227.081-.314.175-.279.4a.961.961,0,0,1,0,.223.536.536,0,0,1-1.063.01c-.013-.154,0-.311,0-.427-.39-.129-.758-.238-1.115-.374a1.765,1.765,0,0,1-.435-.266.53.53,0,0,1,.608-.867,2.047,2.047,0,0,0,.939.362V69.294c0-.431-.006-.863,0-1.294a.247.247,0,0,0-.172-.268,3.773,3.773,0,0,1-.489-.265,1.888,1.888,0,0,1-.233-3.071,2.248,2.248,0,0,1,.423-.286,4.672,4.672,0,0,1,.459-.192Zm1.087,4.362v2.129a1.264,1.264,0,0,0,.746-1.326A.934.934,0,0,0,251.78,68.28Zm-1.1-3.213a.991.991,0,0,0-.476.98c.028.28.231.423.476.549Z",
    transform: "translate(-241.556 -62.96)",
    fill: "#1f2e3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2942",
    "data-name": "Path 2942",
    d: "M165.179,290.962h5.115c.525,0,.851.357.676.722a.625.625,0,0,1-.55.343c-.09.006-.18.007-.271,0h-9.96a2.914,2.914,0,0,1-.3-.006.531.531,0,1,1,.01-1.06q.135-.009.27,0Z",
    transform: "translate(-159.338 -277.392)",
    fill: "#1f2e3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2943",
    "data-name": "Path 2943",
    d: "M205.578,256.071h-3.8c-.55,0-.894-.4-.668-.76a.777.777,0,0,1,.725-.311c1.428,0,2.856,0,4.284,0h3.206c.491,0,.8.21.8.536s-.313.536-.8.536Z",
    transform: "translate(-198.447 -243.572)",
    fill: "#1f2e3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2944",
    "data-name": "Path 2944",
    d: "M138,64.068h-2.259c-.426,0-.7-.218-.7-.543s.274-.525.687-.525h4.593c.41,0,.68.214.683.531s-.268.536-.675.539C139.559,64.071,138.781,64.068,138,64.068Z",
    transform: "translate(-135.048 -62.998)",
    fill: "#1f2e3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2945",
    "data-name": "Path 2945",
    d: "M138.008,99h2.284c.429,0,.7.212.7.536s-.275.536-.706.536H135.7c-.492,0-.8-.373-.615-.742a.606.606,0,0,1,.6-.328Z",
    transform: "translate(-135.028 -96.855)",
    fill: "#1f2e3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2946",
    "data-name": "Path 2946",
    d: "M138.008,99h2.284c.429,0,.7.212.7.536s-.275.536-.706.536H135.7c-.492,0-.8-.373-.615-.742a.606.606,0,0,1,.6-.328Z",
    transform: "translate(-135.028 -94.712)",
    fill: "#1f2e3d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionIcon);
export default __webpack_public_path__ + "static/media/subscription-icon.cca63784872b2d1ed990659730c8b638.svg";
export { ForwardRef as ReactComponent };